<template>
  <div class="fp-video" v-if="list.length" @mouseenter="pauseSlider()" @mouseleave="autoPlay()">
    <div class="fp-video-list" :style="'transform: translate3d(-' + sliderView.offset + 'px, 0, 0)'">
      <div class="fp-video-item" v-for="video, key in list" :ref="'video-' + key">
        <div class="fp-video-item-source" :class="{ 'fp-video-item-source--show': video.show }">
          <div class="gch-skeleton-outer" v-if="!video.show">
            <div class="gch-skeleton"></div>
          </div>
          <div class="fp-video-item-play" v-else-if="!video.play"></div>
          <video
            v-if="video.visible"
            :src="video.src + '#t=0.1'"
            :muted="video.muted"
            @click="toggleVideo($event, video)"
            playsinline
            preload="metadata"
          />
          <div
            v-if="video.play"
            @click="toggleVolume(video)"
            class="g-product-video-volume" :class="{ 'g-product-video-volume--muted': video.muted }"
          >
            <svg v-if="video.muted" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
              <path d="M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
              <path d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z" />
            </svg>
          </div>
          <div class="fp-video-item-footer" v-if="video.show && !video.play">
            <a class="fp-video-item-link fp-video-item-link--vk"
               href="https://vk.com/garshinka?from=stor_vk"
               target="_blank"
               v-if="key % 3 === 0"
            >
              <svg>
                <use x="0" y="0" xlink:href="#social-icon-vk"></use>
              </svg>
              Подписаться
            </a>
            <a class="fp-video-item-link fp-video-item-link--telegram"
               href="https://t.me/garshinka_plants?from=stor_tg"
               target="_blank"
               v-else-if="key % 3 === 1"
            >
              <svg>
                <use x="0" y="0" xlink:href="#social-icon-telegram"></use>
              </svg>
              Подписаться
            </a>
            <a class="fp-video-item-link fp-video-item-link--youtube"
               href="https://www.youtube.com/channel/UCwtRn1PCoNSplqvZ43gFS-A?sub_confirmation=1&from=stor_yt"
               target="_blank"
               v-else
            >
              <svg viewBox="0 0 28.57 20" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z"></path>
                <path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="#FF0000"></path>
              </svg>
              Подписаться
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      list: [],
      isMobile: window.innerWidth < 642,
      slider: {
        page: 0,
        maxScroll: 0,
        slideWidth: 0,
        interval: null
      }
    }
  },
  computed: {
    sliderView() {
      const slider = {
        offset: 0,
        isLastPage: false
      }

      if (!this.slider.maxScroll) {
        return slider
      }

      slider.offset = this.slider.page * this.slider.slideWidth
      if (slider.offset > this.slider.maxScroll) {
        slider.offset = this.slider.maxScroll
      }

      slider.isLastPage = slider.offset >= this.slider.maxScroll

      return slider
    },
  },
  methods: {
    getList() {
      axios.get('/slider/get-front-promos-videos').then((response) => {
        this.list = (response.data || []).map((item) => {
          return { src: item, play: false, muted: true }
        })
        if (this.list.length) {
          this.$nextTick(() => {
            this.makeSlider()
            this.videoObserver()
          })
        }
      })
    },
    makeSlider() {
      if (this.isMobile) {
        return
      }

      const overlay = this.$el.querySelector('.fp-video-list')

      this.slider.slideWidth = overlay.querySelector('.fp-video-item').getBoundingClientRect().width
      this.slider.maxScroll = Array.from(overlay.querySelectorAll('.fp-video-item')).reduce((acc, item) => {
        return acc + item.getBoundingClientRect().width
      }, -overlay.getBoundingClientRect().width)

      this.autoPlay()
    },
    async videoObserver() {
      await this.$nextTick()

      for (let index = 0; index < this.list.length; index++) {
        const element = this.$refs[`video-${ index }`]
        const item = this.list[index]
        if (!element) {
          this.$set(item, 'visible', true)
          this.$set(item, 'show', true)
          continue
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.$set(item, 'visible', true)
              observer.unobserve(entry.target)

              this.$nextTick(() => {
                const videoElement = entry.target.querySelector('video')
                if (!videoElement) {
                  this.$set(item, 'show', true)
                  return
                }

                videoElement.addEventListener('loadeddata', () => {
                  this.$set(item, 'show', true)
                }, false)
              })
            }
          })
        })

        observer.observe(element[0])
      }
    },
    autoPlay() {
      if (this.isMobile) {
        return
      }

      this.slider.interval = setInterval(this.moveSlider, 4000)
    },
    pauseSlider() {
      clearInterval(this.slider.interval)
    },
    moveSlider() {
      if (this.sliderView.isLastPage) {
        this.slider.page = 0
        return
      }

      this.slider.page++
    },
    toggleVideo(e, video) {
      if (video.play) {
        video.play = false
        e.target.pause()
      }
      else {
        video.play = true
        e.target.play()
      }
    },
    toggleVolume(video) {
      video.muted = !video.muted
    }
  },
  created() {
    this.getList()
  }
}
</script>